import { createFileRoute } from "@tanstack/react-router";
import { AdminLogsPage } from "@/components/admin/pages/AdminLogsPage";

export const Route = createFileRoute("/pulse-ops-x7k2/logs/")({
  component: AdminLogsPage,
});
